import type { CloudMaterial, TemporaryMaterial } from '../../../features/materials/materialsSlice';

// 'storyboard' はストーリーボード画像プレビュー専用の仮想タブ。
// storyboardImageUrl が立っている間だけ第3タブとして出現し、素材グリッドの代わりに
// 絵コンテ画像を表示する。素材取得・配置マップには参加しないが、型整合のため列挙する。
// 'catalog' は音声ピッカー (MaterialsPickerModal) の「提供ライブラリ」タブ。運営 / パートナー提供の
// 効果音・フリー楽曲 (audio_catalog_items) を出す。素材ではないので、こちらも素材マップには参加しない。
export type TabType = 'cloud' | 'temporary' | 'storyboard' | 'catalog';
// 外部制御 (activeTab / onTabChange) で扱うタブ。'catalog' は内部状態でだけ切り替える
// (提供ライブラリタブを出すピッカーはタブを外部制御しない)。
export type ControlledTabType = Exclude<TabType, 'catalog'>;
// 素材マップ (deletedPlaceholdersMap / displayOrderMap) のキー型。'storyboard' は除外。
export type MaterialsTab = 'cloud' | 'temporary';

export type AnyMaterial = CloudMaterial | TemporaryMaterial;

export type PlaceholderEntry = {
  material: AnyMaterial;
  cardHeight?: number;
  previewHeight?: number;
};

export type DisplayEntry = {
  id: string;
  material: AnyMaterial;
  isDeleted: boolean;
  placeholder?: PlaceholderEntry;
};

export const makeCompositeKey = (tab: MaterialsTab, id: string) => `${tab}:${id}`;

// ASIN値を文字列に正規化
export function normalizeAsinForDisplay(asin?: string | string[]): string {
  if (!asin) return '';
  if (typeof asin === 'string') return asin;
  return asin.join(', ');
}

/** 素材パネル → 素材ページ遷移時に引き継ぐフィルタ状態のスナップショット */
export interface MaterialsFilterSnapshot {
  search: string;
  fileTypes: string[];
  aspectRatios: string[];
  sourceTypes: string[];
  tags: string[];
  workflowStages: string[];
  product: string;
  brandId: string;
}

/** sessionStorage で素材ページへフィルタを引き継ぐ際のキー */
export const MATERIALS_FILTER_CARRYOVER_KEY = 'materials_filter_carryover';
